import { useListContext } from '../ListContext';
import { useUiTheme } from 'framework/uiTheme';
import Loading from '../../ui/mui-builder/Loading/Loading';

const LoadingListLayout = () => {
  const { loading } = useListContext();
  const { Loading: ThemedLoading = Loading } = useUiTheme();

  return loading ? <ThemedLoading /> : null;
};

export default LoadingListLayout;
